import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import { SimpleGraphQLComponent } from '../../utils/apollo';
import Scholarships from './scholarships';
import saveScholarships from '../../mutations/Scholarships/saveScholarships';

const query = gql`
  query Scholarships {
    viewer {
      id
      scholarships {
        id
        url
        addInfo
        meritBasedScholarships {
          name
          awardType
          awAmountMin
          awAmountMax
          renewable
          gpaMin
          gpaMax
          gpaRankMatch
          classRankMin
          classRankMax
          satGpaMatch
          satMin
          satMax
          satActMatch
          actMin
          actMax
          audience
          audienceStates
        }
      }
    }
  }
`;

const graphqlData = graphql(query, {
  options: {
    fetchPolicy: 'network-only',
  },
});

const saveScholarshipsMutation = graphql(saveScholarships, {
  name: 'saveScholarshipsMutation',
});

export default SimpleGraphQLComponent(
  graphqlData,
  saveScholarshipsMutation,
)(Scholarships);
